import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./i18n";

let rootEl = document.getElementById("root");
if (!rootEl) {
  // Safety net: a stale/broken prerendered page may lack #root — recreate it.
  rootEl = document.createElement("div");
  rootEl.id = "root";
  document.body.appendChild(rootEl);
}
createRoot(rootEl).render(<App />);

// Signal to the prerenderer (scripts/prerender.ts) that the app has hydrated
// and Helmet has flushed per-route <head> tags into the DOM. We wait two RAFs
// so React has committed and react-helmet-async has applied its mutations.
if (typeof window !== "undefined") {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      document.dispatchEvent(new Event("render-event"));
    });
  });
}
